export default {
  locations: [
    {
      value: 'NONE',
      label: 'Не указано',
    },
    {
      value: 'SUNRISE',
      label: 'Облако',
    },
    {
      value: 'SUNRISE_MCP',
      label: 'Новое облако',
    },
    {
      value: 'EXTERNAL',
      label: 'Внешний сервер',
    },
  ],
  statuses: [
    {
      value: 'ACTIVE',
      label: 'Активный',
    },
    {
      value: 'NEW_DEMO',
      label: 'Новая демка',
    },
    {
      value: 'REMOVED',
      label: 'Удалён',
    },
    {
      value: 'PENDING_REMOVE',
      label: 'В списке на удаление',
    },
    {
      value: 'ERROR_REMOVING',
      label: 'Ошибка удаления',
    },
    {
      value: 'DEMO_IN_WORK',
      label: 'Демка в работе',
    },
    {
      value: 'UNCERTAIN_DEBTOR',
      label: 'Неопределенный должник',
    },
    {
      value: 'TRIAL_ENDED_WITHOUT_SERVICE',
      label: 'Закончился триал - Без тарифа',
    },
    {
      value: 'TRIAL_ENDED_SERVICE_SELECTED',
      label: 'Закончился триал - Тариф выбран',
    },
    {
      value: 'DEBTOR_ADMIN_IS_LOCKED',
      label: 'Должник - Заблокирована админка',
    },
    {
      value: 'DEBTOR_FRONT_IS_LOCKED',
      label: 'Должник - Заблокирован фронт',
    },
    {
      value: 'DEBTOR_ARCHIVE',
      label: 'Должник - Заархивирован',
    },
    {
      value: 'SYSTEM',
      label: 'Системный',
    },
    {
      value: 'POSTPONEMENT',
      label: 'Отсрочка',
    },
  ],
  billStatuses: [
    {
      value: 'EXPIRED',
      label: 'Просрочена оплата',
    },
    {
      value: 'NEW',
      label: 'Новый',
    },
    {
      value: 'REFUSED',
      label: 'Отклонен',
    },
    {
      value: 'PAID',
      label: 'Оплачен',
    },
    {
      value: 'PARTIALLY_PAID',
      label: 'Частично оплачен',
    },
    {
      label: 'Возврат',
      value: 'REFUNDED',
    },
  ],
  services: [
    {
      value: 'basic_design_from_gallery',
      label: 'Дизайн из галереи',
    },
    {
      value: 'basic_individual_design',
      label: 'Индивидуальная настройка дизайна',
    },
    {
      value: 'cloud_2.0_basic_monthly',
      label: 'BASIC (месяц)',
    },
    {
      value: 'cloud_2.0_basic_yearly',
      label: 'BASIC (год)',
    },
    {
      value: 'cloud_2.0_standard_monthly',
      label: 'STANDARD (месяц)',
    },
    {
      value: 'cloud_2.0_standard_yearly',
      label: 'STANDARD (год)',
    },
    {
      value: 'cloud_2.0_pro_monthly',
      label: 'PRO (месяц)',
    },
    {
      value: 'cloud_2.0_pro_yearly',
      label: 'PRO (год)',
    },
    {
      value: 'cloud_2.0_pro_x_monthly',
      label: 'PRO-X (месяц)',
    },
    {
      value: 'cloud_2.0_pro_x_yearly',
      label: 'PRO-X (год)',
    },
    {
      value: 'cloud_2.0_b2b_x_monthly',
      label: 'B2B-X (месяц)',
    },
    {
      value: 'cloud_2.0_b2b_x_yearly',
      label: 'B2B-X (год)',
    },
    {
      value: 'cloud_2.0_enterprise_monthly',
      label: 'ENTERPRISE (месяц)',
    },
    {
      value: 'cloud_2.0_enterprise_yearly',
      label: 'ENTERPRISE (год)',
    },
    {
      value: 'cloud_2.0_b2b_monthly',
      label: 'B2B (месяц)',
    },
    {
      value: 'cloud_2.0_b2b_yearly',
      label: 'B2B (год)',
    },
    {
      value: 'cloud_2.0_personal',
      label: 'Personal',
    },
    {
      value: 'b2b_portal',
      label: 'B2B Портал',
    },
    {
      value: 'basic_design_from_gallery_liqpay',
      label: 'Дизайн из галереи - LiqPay Edition',
    },
    {
      value: 'basic_individual_design_liqpay',
      label: 'Индивидуальная настройка дизайна - LiqPay Edition',
    },
    {
      value: 'discount_design_from_gallery',
      label: 'Дизайн со скидкой 30%',
    },

    {
      value: 'basic_cloud_demo',
      label: 'Cloud Demo',
    },
    {
      value: 'basic_cloud_a_monthly',
      label: 'Cloud A (месяц)',
    },
    {
      value: 'basic_cloud_a_yearly',
      label: 'Cloud A (год)',
    },
    {
      value: 'basic_cloud_b_monthly',
      label: 'Cloud B (месяц)',
    },
    {
      value: 'basic_cloud_b_yearly',
      label: 'Cloud B (год)',
    },
    {
      value: 'basic_cloud_c_monthly',
      label: 'Cloud C (месяц)',
    },
    {
      value: 'basic_cloud_c_yearly',
      label: 'Cloud C (год)',
    },
    {
      value: 'basic_cloud_d_monthly',
      label: 'Cloud D (месяц)',
    },
    {
      value: 'basic_cloud_d_yearly',
      label: 'Cloud D (год)',
    },

    {
      value: 'basic_cloud_e_monthly',
      label: 'Cloud E (месяц)',
    },
    {
      value: 'basic_cloud_e_yearly',
      label: 'Cloud E (год)',
    },
    {
      value: 'cloud_2.0_demo',
      label: 'Demo',
    },
    {
      value: 'legacy-smart',
      label: 'Смарт',
    },
    {
      value: 'legacy-start',
      label: 'Старт',
    },
    {
      value: 'legacy-super',
      label: 'Супер',
    },
    {
      value: 'legacy-super-plus',
      label: 'Супер+',
    },
    {
      value: 'custom',
      label: 'Индивидуальные доработки',
    },
  ],
  roles: [
    {
      value: 'root',
      label: 'Админ',
    },
    {
      value: 'manager',
      label: 'Менеджер',
    },
    {
      value: 'user',
      label: 'Пользователь',
    },
    {
      value: 'accountant',
      label: 'Бухгалтер',
    },
  ],
  userType: [
    {
      value: 0,
      label: 'Физлицо',
    },
    {
      value: 1,
      label: 'ФОП',
    },
    {
      value: 4,
      label: 'ФОП плательщик НДС',
    },
    {
      value: 2,
      label: 'Предприятие плательщик НДС',
    },
    {
      value: 3,
      label: 'Предприятие не плательщик НДС',
    },
  ],
  autoPayment: [
    {
      value: false,
      label: 'Выключена',
    },
    {
      value: true,
      label: 'Включена',
    },
  ],
  logType: [
    {
      value: 'PROJECT_WAS_UPDATED',
      label: 'Редактирование проекта',
    },
    {
      value: 'PROJECT_WAS_DELETED',
      label: 'Удаление проекта',
    },
    {
      value: 'PROJECT_OWNER_WAS_CHANGED',
      label: 'Изменение владельца проекта',
    },
    {
      value: 'PROJECT_SERVICE_PROVIDER_WAS_CHANGED',
      label: 'Изменение поставщика услуг',
    },
    {
      value: 'PROJECT_DOMAIN_WAS_ADDED',
      label: 'Добавление домена',
    },
    {
      value: 'PROJECT_DOMAIN_WAS_CHANGED',
      label: 'Редактирование домена',
    },
    {
      value: 'PROJECT_DOMAIN_WAS_REMOVED',
      label: 'Удаление домена',
    },
    {
      value: 'PROJECT_SSL_WAS_ACTIVATED',
      label: 'Включение ssl',
    },
    {
      value: 'PROJECT_DOMAIN_WAS_DEACTIVATED',
      label: 'Выключение ssl',
    },
    {
      value: 'PROJECT_SSL_WAS_CHANGED',
      label: 'Редактирование ssl',
    },
    {
      value: 'PROJECT_LOGS_WERE_CLEARED',
      label: 'Очистка логов',
    },
    {
      value: 'PROJECT_TAG_WAS_ADDED',
      label: 'Добавление тега',
    },
    {
      value: 'PROJECT_TAGS_WERE_CHANGED',
      label: 'Редактирование тега',
    },
    {
      value: 'PROJECT_TAG_WAS_REMOVED',
      label: 'Удаление тега',
    },
    {
      value: 'PROJECT_COMMENT_WAS_DELETED',
      label: 'Удаление комментария',
    },
    {
      value: 'BILL_WAS_CREATED',
      label: 'Создание счёта',
    },
    {
      value: 'BILL_WAS_UPDATED',
      label: 'Редактирование счёта',
    },
    {
      value: 'BILL_DATE_WAS_UPDATED',
      label: 'Редактирование даты оплаты',
    },
    {
      value: 'BILL_COMMENT_WAS_UPDATED',
      label: 'Обновление комментария счёта',
    },
    {
      value: 'BILL_PAID_AMOUNT_CHANGED',
      label: 'Внесение оплаты',
    },
    {
      value: 'BILL_PAYMENT_METHOD_WAS_UPDATED',
      label: 'Редактирование способа оплаты',
    },
    {
      value: 'BILL_WAS_DELETED',
      label: 'Удаление счёта',
    },
    {
      value: 'SERVICE_WAS_CREATED',
      label: 'Добавление услуги',
    },
    {
      value: 'SERVICE_WAS_UPDATED',
      label: 'Редактирование услуги',
    },
    {
      value: 'SERVICE_DATE_WAS_UPDATED',
      label: 'Редактирование даты окончания',
    },
    {
      value: 'SERVICE_DESCRIPTION_WAS_CHANGED',
      label: 'Редактирование описания услуги',
    },
    {
      value: 'SERVICE_WAS_ACTIVATED',
      label: 'Активация услуги',
    },
    {
      value: 'SERVICE_WAS_DEACTIVATED',
      label: 'Выключение услуги',
    },
    {
      value: 'SERVICE_WAS_DELETED',
      label: 'Удаление услуги',
    },
    {
      value: 'USER_ATTRIBUTES_WERE_CHANGED',
      label: 'Редактирование атрибутов пользователя',
    },
    {
      value: 'USER_PAYMENT_DATA_WAS_CHANGED',
      label: 'Редактирование реквизитов пользователя',
    },
    {
      value: 'NOTIFICATION_WAS_SEND',
      label: 'Отправка счета клиенту',
    },
    {
      value: 'BALANCE_AMOUNT_HAS_BEEN_CHANGED',
      label: 'Изменение баланса',
    },
    {
      value: 'PROJECT_LOCK_STATUS_WAS_CHANGED',
      label: 'Смена статуса проекта',
    },
  ],
  transactionType: [
    {
      value: 'income',
      label: 'Приход',
    },
    {
      value: 'charge',
      label: 'Расход',
    },
  ],

  maxValidDaysForService: [
    {
      value: 'auto',
      label: 'auto',
    },
    {
      value: '2 days',
      label: '2 дня',
    },
    {
      value: '7 days',
      label: '7 дней',
    },
    {
      value: '14 days',
      label: '14 дней',
    },
    {
      value: '1 month',
      label: '1 месяц',
    },
    {
      value: '2 months',
      label: '2 месяца',
    },
    {
      value: '3 months',
      label: '3 месяца',
    },
    {
      value: '4 months',
      label: '4 месяца',
    },
    {
      value: '5 months',
      label: '5 месяцев',
    },
    {
      value: '6 months',
      label: '6 месяцев',
    },
    {
      value: '7 months',
      label: '7 месяцев',
    },
    {
      value: '8 months',
      label: '8 месяцев',
    },
    {
      value: '9 months',
      label: '9 месяцев',
    },
    {
      value: '10 months',
      label: '10 месяцев',
    },
    {
      value: '11 months',
      label: '11 месяцев',
    },
    {
      value: '12 months',
      label: '12 месяцев',
    },
    {
      value: '13 months',
      label: '13 месяцев',
    },
  ],

  regions: [
    {
      value: 'Global',
      label: 'Global',
    },
    {
      value: 'EU',
      label: 'EU',
    },
    {
      value: 'MD',
      label: 'MD',
    },
    {
      value: 'UA',
      label: 'UA',
    },
  ],

  paymentMethods: [
    {
      value: 'wayforpay',
      label: 'WayForPay',
    },
    {
      value: 'liqpay',
      label: 'LiqPay',
    },
    {
      value: 'privat24',
      label: 'Приват24',
    },
    {
      value: 'balance',
      label: 'Баланс',
    },
    {
      value: 'bonus',
      label: 'Бонусы',
    },
    {
      value: 'stripe',
      label: 'Stripe',
    },
  ],
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/HTable/columnsValues.js